module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.data !== null) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "fade-in-down"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Solicitação de Remoção")]), _vm._v(" "), _c('span', {
    staticClass: "label no-radius bg-dark"
  }), _vm._v(" "), _c('span', {
    staticClass: "label m-l-n-xxs no-radius bg-success"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "visible-xs m-t-lg"
  }), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-info pull-right pull-none-xs hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.print($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print m-r-xs"
  }), _vm._v(" Imprimir\n            ")]), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-default pull-right pull-none-xs hidden-print m-r",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.criarGrv($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file m-r-xs"
  }), _vm._v(" Criar GRV para esta solicitação\n            ")]), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-primary pull-right pull-none-xs hidden-print m-r",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.SolicitarReboque($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-car m-r-xs"
  }), _vm._v("Iniciar Atendimento\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "pull-right pull-none-xs hidden-print m-t-xs m-r",
    staticStyle: {
      "clear": "left"
    },
    attrs: {
      "to": {
        name: 'solicitacoes-remocao'
      }
    }
  }, [_c('strong', {
    staticClass: "label no-radius bg-info"
  }, [_vm._v("Voltar")])])], 1)])]), _vm._v(" "), _c('div', {
    ref: "mapIn",
    staticClass: "map",
    attrs: {
      "id": "mapIn"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row wrapper-md"
  }, [_c('div', {
    staticClass: "col-sm-2 label-info"
  }, [_c('span', [_vm._v("Deslocamento Ida :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.kmIda) + " / " + _vm._s(_vm.timeIda))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 label-info"
  }, [_c('span', [_vm._v("Deslocamento Volta :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.kmVolta) + " / " + _vm._s(_vm.timeVolta))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 label-info"
  }, [_c('span', [_vm._v("Deslocamento Total :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.kmTotal) + " / " + _vm._s(_vm.timeTotal))])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('h4', [_vm._v("Solicitação nº #" + _vm._s(_vm.data.id))]), _vm._v(" "), _c('p', [_vm._v("Placa: " + _vm._s(_vm.data.placa || '-'))]), _vm._v(" "), _c('p', [_vm._v("Veículo: " + _vm._s(_vm.data.nomeVeiculo || '-'))]), _vm._v(" "), _c('p', _vm._l((_vm.data.grvs), function(grv) {
    return _c('span', [_vm._v("GRV: " + _vm._s(grv.numero)), _c('br')])
  }), 0), _vm._v(" "), _c('p', [_vm._v("\n              Agente: "), _c('span', [_vm._v(_vm._s(_vm.data.nomeAgente))])]), _vm._v(" "), _c('p', [_vm._v("\n              Tipo de Veículo: "), _c('span', [_vm._v(_vm._s(_vm.data.categoria ? _vm.data.categoria.nome : '-'))])]), _vm._v(" "), _c('p', [_vm._v("\n              Pátio de Destino: "), _c('span', [_vm._v(_vm._s(_vm.data.patioDestino ? _vm.data.patioDestino.nome : '-'))])]), _vm._v(" "), _c('p', [_vm._v("\n              Endereço de Recolhimento: "), _c('span', [_vm._v(_vm._s(_vm.data.enderecoRecolhimento || '-'))]), _c('br'), _vm._v("\n              Latitude: "), _c('span', [_vm._v(_vm._s(_vm.data.latRecolhimento || '-'))]), _c('br'), _vm._v("\n              Longitude: "), _c('span', [_vm._v(_vm._s(_vm.data.lngRecolhimento || '-'))]), _c('br')]), _vm._v(" "), (_vm.data.observacoes) ? _c('p', [_vm._v("\n              Observações:"), _c('br'), _c('br'), _vm._v("\n              " + _vm._s(_vm.data.observacoes) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right text-left-print"
  }, [_c('p', {
    staticClass: "h4"
  }, [_vm._v("#" + _vm._s(_vm.data.id))]), _vm._v(" "), _c('h5', [_vm._v("Data de Início: " + _vm._s(_vm.moment(_vm.data.dataInicio && _vm.data.dataInicio.date).format('L LTS')))]), _vm._v(" "), _c('h5', [_vm._v("Início do Recolhimento: " + _vm._s(_vm.data.dataInicioRecolhimento && _vm.moment(_vm.data.dataInicioRecolhimento.date).format('L LTS')))]), _vm._v(" "), _c('h5', [_vm._v("Início do Transporte: " + _vm._s(_vm.data.dataInicioTransporte && _vm.moment(_vm.data.dataInicioTransporte.date).format('L LTS')))]), _vm._v(" "), _c('h5', [_vm._v("Entrega: " + _vm._s(_vm.data.dataEntrega && _vm.moment(_vm.data.dataEntrega.date).format('L LTS')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "m-b m-t-lg"
  }, [_vm._v("Fotos")]), _vm._v(" "), (_vm.data.fotos && _vm.data.fotos.length) ? _c('div', {
    staticClass: "fotos-flex"
  }, _vm._l((_vm.data.fotos), function(foto, index) {
    return _c('div', {
      staticClass: "foto",
      attrs: {
        "id": 'solic-foto-' + foto.id
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.acessarLinkPublicoImagemCompleta(foto.id)
        }
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": foto.imageInfo && foto.imageInfo.min.url
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "11px"
      }
    }, [_c('div', [_vm._v("Foto registrada " + _vm._s(_vm._f("formatDate")(foto.storageCreatedAt.date, 'DD/MM/YYYY HH:mm:s')))]), _vm._v(" "), _c('div', [_vm._v("GPS: Lat: " + _vm._s(String(foto.gps.lat)) + ", Lng: " + _vm._s(String(foto.gps.lng)))])])])
  }), 0) : _c('div', [_vm._v("Nenhuma foto cadastrada")])])]), _vm._v(" "), _c('br'), _c('br'), _c('br')])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e27ddc6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/solicitacao-remocao/components/VisualizarSolicitacao.vue
// module id = 1724
// module chunks = 17